import t,{css as r}from"styled-components";import{RobotoFontStyle as o}from"../../../../style/fonts/robotoFont.js";const n=r`
  box-shadow: 0 0 1px 0 #a39f98, 0 1px 1px 0 rgba(164, 152, 135, 0.32);
  background: #e1ffc7;
  border-radius: 7px 0px 7px 7px;
`,p=t.div`
  position: relative;
  bottom: -4px;
  color: rgba(0, 0, 0, 0.45);

  ${({RTLLayout:t})=>t?"float: left; padding: 0 7px 0 0;":"float: right; padding: 0 0 0 7px;"}

  ${({fixed:t,RTLLayout:o})=>t&&r`
      position: absolute;
      bottom: 3px;
      color: rgba(255, 255, 255, 0.9);

      ${o?"left: 6px;":"right: 6px"}
    `}

  ${({incoming:t,RTLLayout:o})=>t&&r`
      ${o?"float: left; left: 8px;":"float: right; right: 8px;"}
    `}
`,a=t.div`
  ${o}
  ${n}
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 15px;
  padding: 9px 4.5px 6px 4.5px;
  position: relative;
  margin: 8px 0;
  max-width: 85%;
  overflow-wrap: anywhere;
  box-sizing: content-box;

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
  }

  ${({fixed:t})=>t&&r`
      padding: 3px;
    `}

  ${({RTLLayout:t})=>t?`direction: rtl; float: left; border-radius: 0px 5px 5px 5px; ${e} { float: left; margin-right: 2px }`:`float: right; border-radius: 7px 0px 7px 7px; ${e} { margin-left: 2px }`}

  ${({incoming:t,RTLLayout:o})=>t?r`
          background: #fff;

          ${o?"\n            border-radius: 7px 0px 7px 7px;\n            float: right;\n          ":"\n              border-radius: 0px 5px 5px 5px;\n              float: left;\n          "};

          &:after {
            top: 0;

            ${o?"\n              border-width: 0px 0 10px 10px;\n              border-color: transparent transparent transparent #fff;\n              right: -10px;\n            ":"\n              border-width: 0px 10px 10px 0;\n              border-color: transparent #fff transparent transparent;\n              left: -10px;\n            "};
          }
        `:r`
          &:after {
            border-width: 0px 0 10px 10px;
            top: 0;

            ${o?"\n              border-width: 0px 10px 10px 0;\n              border-color: transparent #e1ffc7 transparent transparent;\n              left: -10px;\n            ":"\n              border-width: 0px 0 10px 10px;\n              border-color: transparent transparent transparent #e1ffc7;\n              right: -10px;\n            "};
          }
        `}

  ${p} {
    ${({transparent:t})=>t&&r`
        ${n}
        border-radius: 7px;
        float: none;
        position: absolute;
        bottom: -18px;
        right: 0;
      `}

    ${({transparent:t,incoming:o})=>t&&o&&r`
        ${n}
        background: #fff;
        border-radius: 7px;
        float: none;
        position: static;
        display: inline-block;
      `}
  }

  ${({transparent:t})=>t&&r`
      background: transparent;
      box-shadow: none;
      right: 0;

      &:after {
        display: none;
      }
    `}
`,i=t.span`
  font-size: 11px;
  display: inline-block;
  position: relative;
  z-index: 1;
`,e=t.span`
  display: inline-block;
  position: relative;
  top: 4px;
  height: 16px;
  width: 16px;
  z-index: 1;
`,x=t.div`
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0) 0%,
    rgb(0 0 0 / 45%) 140%
  );

  padding-left: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0px;
  border-radius: 0 6px 6px 0;
  right: -2px;
  z-index: 0;
`;t.img`
  display: block;
  border-radius: 6px;
  width: 100%;
`;const d=t.button`
  font-size: 14px;
  padding: 9px 10px;
  background: #fff;
  color: #18b2f4;
  font-weight: bold;
  margin: 2px 0;
  box-shadow: 0 0 1px 0 #a39f98, 0 1px 1px 0 rgba(164, 152, 135, 0.32);
  border: unset;
  border-radius: 10px;
  width: 100%;
  text-align: center;
`;export{d as Button,x as DateShadow,p as Metadata,e as Tick,i as Time,a as Wrapper};
//# sourceMappingURL=styled.js.map
